import { useEffect, useState } from 'react';
import { useImpersonation } from './useImpersonation';

/**
 * Oculta secciones administrativas sensibles (proyeccion de cumplimiento, auto-aprobar, etc.)
 * por defecto. Solo un sysadmin suplantando al admin (switchToAdmin) puede revelarlas, y aun
 * asi arrancan ocultas hasta presionar Ctrl+. (toggle). El atajo no tiene efecto si el admin
 * no esta siendo suplantado.
 */
export function useAdminSecretPanel(): boolean {
  const [visible, setVisible] = useState(false);

  let isImpersonating = false;
  try {
    const imp = useImpersonation();
    isImpersonating = imp.isImpersonating;
  } catch {
    // Si se ejecuta en un test unitario aislado sin AuthProvider, resalta seguro en false
    isImpersonating = false;
  }

  useEffect(() => {
    if (!isImpersonating) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === '.') {
        e.preventDefault();
        setVisible((prev) => !prev);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isImpersonating]);

  return isImpersonating && visible;
}
